import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../services/common/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../../app.component.scss', './header.component.scss']
})
export class HeaderComponent implements OnInit {
  constructor(public commonService: CommonService) {
  }

  ngOnInit() {
  }
}
